export class AlertMessage{
  type: string;
  message: string;
  chatType = false;
  chatChannelId: string;
}
